import { motion } from "framer-motion";
import { ArrowRight, Clock, Facebook, Instagram, Mail, MapPin, Phone, Twitter, Youtube } from "lucide-react";
import Logo from "./Logo";

const SOCIALS = [
  { name: "Facebook", href: "https://www.facebook.com/share/1FoJ3T73kw/", Icon: Facebook },
  { name: "Instagram", href: "https://www.instagram.com/aircon.khan", Icon: Instagram },
  { name: "X", href: "https://www.x.com/@MdSadique1975", Icon: Twitter },
  { name: "YouTube", href: "https://www.youtube.com/@Aircon_khan", Icon: Youtube },
];

const EASE = [0.76, 0, 0.24, 1];

export default function Footer({ onBook }) {
  const year = new Date().getFullYear();
  return (
    <footer id="contact" className="bg-ink border-t border-white/10">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 pt-24 md:pt-32 pb-10">
        <motion.div
          initial={{ opacity: 0, y: 36 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.7, ease: EASE }}
          className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-10 pb-20"
        >
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-signal mb-4">
              (07) — Book the road
            </p>
            <h2 className="font-display font-black uppercase leading-[0.92] text-5xl sm:text-6xl lg:text-7xl">
              Ready when
              <br />
              you are.
            </h2>
          </div>
          <button
            data-testid="footer-book-btn"
            onClick={() => onBook()}
            className="group self-start inline-flex items-center gap-3 bg-signal text-ink font-mono text-xs uppercase tracking-[0.22em] px-10 py-5 hover:bg-bone transition-colors duration-200"
          >
            Book Now
            <ArrowRight size={15} className="transition-transform duration-200 group-hover:translate-x-1" />
          </button>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10 border-t border-white/10 py-14">
          <div className="flex items-start gap-3">
            <Logo />
            <div>
              <div className="font-display uppercase text-lg">Aircon <span className="text-signal">Travel</span></div>
              <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-zinc-500 mt-1">
                Mr. Md Sadique, Owner
              </p>
            </div>
          </div>
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-signal mb-3 flex items-center gap-2">
              <Phone size={13} /> Dispatch desk
            </p>
            <a href="tel:+919827953314" data-testid="footer-phone-link" className="text-lg hover:text-signal transition-colors duration-200">
              +91 98279 53314
            </a>
          </div>
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-signal mb-3 flex items-center gap-2">
              <Mail size={13} /> Email
            </p>
            <a href="mailto:airo@aircontravel.com" data-testid="footer-email-link" className="text-lg hover:text-signal transition-colors duration-200">
              airo@aircontravel.com
            </a>
          </div>
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-signal mb-3 flex items-center gap-2">
              <MapPin size={13} /> The yard
            </p>
            <p data-testid="footer-address" className="text-base text-zinc-300 leading-relaxed">
              Plot 1078, Phase-2, Dumduma,<br />Bhubaneswar-19
            </p>
          </div>
        </div>

        <div className="border-t border-white/10 py-8 flex flex-col sm:flex-row flex-wrap items-start sm:items-center justify-between gap-6">
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-signal mb-2 flex items-center gap-2">
              <Clock size={13} /> Open hours
            </p>
            <p data-testid="footer-hours" className="text-base text-zinc-300">
              Every day · 7:00 AM – 11:30 PM
            </p>
          </div>
          <div className="flex items-center gap-3">
            {SOCIALS.map(({ name, href, Icon }) => (
              <a
                key={name}
                data-testid={`social-${name.toLowerCase()}`}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Aircon Travel on ${name}`}
                className="inline-flex items-center justify-center w-11 h-11 border border-white/15 text-zinc-400 hover:text-signal hover:border-signal transition-colors duration-200"
              >
                <Icon size={18} strokeWidth={1.8} />
              </a>
            ))}
          </div>
        </div>

        <div className="select-none overflow-hidden" aria-hidden="true">
          <div className="font-display font-black uppercase text-stroke leading-none text-center text-[15.5vw] whitespace-nowrap tracking-tight">
            Aircon Travel
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between gap-2 border-t border-white/10 pt-6 mt-6 font-mono text-[11px] uppercase tracking-[0.18em] text-zinc-500">
          <span>© {year} Aircon Travel</span>
          <span>Every road. One call. Zero hassle.</span>
        </div>
      </div>
    </footer>
  );
}
